import { useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import "./RegisterForm.css";
import show from "../../assets/show.svg";
import hide from "../../assets/hide.svg";
import { toast } from "react-toastify";
import { getErrorToast } from "../../toast";

const CutomToolkit = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#186daa",
    color: "#ffffff",
    maxWidth: 220,
    fontSize: "0.913rem",
    border: "1px solid #dadde9",
    padding: "0.5rem",
    boxShadow: "5px 5px 10px #186daa40",
  },
}));

const Form = () => {
  const axiosPrivate = useAxiosPrivate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [cPassword, setCPassword] = useState("");
  const [userExists, setUserExists] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [nameInfoMsg, setNameInfoMsg] = useState(false);
  const [passwordInfoMsg, setPasswordInfoMsg] = useState(false);
  const [passwordType, setPasswordType] = useState("password");

  const togglePasswordHandler = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    let regix = /([A-Z])/g;
    if (username.match(regix)) {
      getErrorToast("User name can't be Uppercase");
      return;
    }
    let regix2 = /([ ])/g;
    if (username.match(regix2)) {
      getErrorToast("Username should not contain space");
      return;
    }

    if (phone.length !== 10) {
      toast.error("Phone number must be 10 digits");
      setIsLoading(false);
      return;
    }
    if (phone.match(/^[^0-9]/) || phone.charAt(0) === "0") {
      getErrorToast("Please provide valid mobile number");
      return;
    }
    if (
      !password.match(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/)
    ) {
      getErrorToast(
        "Please choose a more secure password. It should be longer than 6 characters, unique to you and difficult for others to guess."
      );
      return;
    }
    if (password !== cPassword) {
      toast.error("Password and Conform Password must match");
      setIsLoading(false);
      return;
    }
    setIsLoading(true);

    try {
      const res = await axiosPrivate.post("/auth/register", {
        username,
        password,
        phone,
      });

      toast.success(res.data.message, {
        theme: "colored",
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setIsLoading(false);
    } catch (err) {
      console.log(err);
      if (err.response.status === 400) {
        setUserExists(true);
      } else {
        toast.errorr("An error occured while registering a user!", {
          theme: "colored",
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const phoneNumberHandler = (e) => {
    if (e.target.value.length === 11) return false;
    setPhone(
      e.target.value.replace(/[^0-9.]/g, "").replace(/(\.. *)\./g, "$1")
    );
  };

  const displayUsernameMsg = () => {
    setNameInfoMsg(true);
  };

  const hideUsernameMsg = () => {
    setNameInfoMsg(false);
  };

  return (
    <div className="register-form-container">
      <h3 className="register-form-heading">Register</h3>
      <form onSubmit={submitHandler} className="register-form">
        <section className="register-form-section">
          <label className="register-form-label" htmlFor="username">
            Username
          </label>
          <CutomToolkit
            title="Special characters and whitespace are not allowed."
            placement="right"
          >
            <input
              required
              onChange={(e) =>
                setUsername(
                  e.target.value
                    .toLowerCase()
                    .replace(/[ `!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?~]/, "")
                )
              }
              value={username}
              type="text"
              className="register-form-input register-form-username-input"
              id="username"
              placeholder="Enter Username"
              maxLength="15"
              onFocus={displayUsernameMsg}
              onBlur={hideUsernameMsg}
              autoComplete="off"
            />
          </CutomToolkit>
        </section>
        <section className="register-form-section">
          <label className="register-form-label" htmlFor="phone">
            Mobile Number
          </label>

          <input
            required
            // onInput={}
            onChange={phoneNumberHandler}
            value={phone}
            type="tel"
            className="register-form-input register-form-phone-input"
            id="phone"
            placeholder="Enter Phone Number"
          />
        </section>
        <section className="register-form-section">
          <label className="register-form-label" htmlFor="password">
            Password
          </label>
          <CutomToolkit
            title="Passwords must be at least 8 characters, including one uppercase,
            one lowercase, one numeric, and one special character."
            placement="right"
          >
            <input
              required
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              type={passwordType}
              className="register-form-input register-form-password-input"
              id="password"
              placeholder="Enter password"
              maxLength="20"
              onFocus={() => setPasswordInfoMsg(true)}
              onBlur={() => setPasswordInfoMsg(false)}
              autoComplete="off"
            />
          </CutomToolkit>
          <img
            onClick={togglePasswordHandler}
            src={passwordType === "password" ? show : hide}
            className="regsiter-password-toggle_icon"
            alt="password-toggle-icon"
          />
        </section>
        <section className="register-form-section">
          <label className="register-form-label" htmlFor="password">
            Confirm Password
          </label>
          <input
            required
            onChange={(e) => setCPassword(e.target.value)}
            value={cPassword}
            type="password"
            className="register-form-input register-form-password-input"
            id="password"
            placeholder="Enter Confirm password"
            maxLength="20"
          />
          {/*<img
            onClick={togglePasswordHandler}
            src={passwordType === "password" ? show : hide}
            className="regsiter-password-toggle_icon"
            alt="password-toggle-icon"
          />*/}
        </section>

        {userExists && (
          <span className="register-form-user-exists-message">
            User already exists
          </span>
        )}
        <section className="register-form-section register-form-button-section">
          <button disabled={isLoading} className="register-form-button">
            Register
          </button>
        </section>
      </form>
    </div>
  );
};

export default Form;
